import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { textToHtml } from 'app/functions/error-parse';
import { getConsiderProductPriceByTypePrice } from 'app/functions/app';
import { Float } from 'app/functions/input-float';
import { find, size } from 'underscore';
import { Modal } from 'app/shared/modal/modal';
import { closeProductModal } from '../actions/setModal';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { ProductTooltip } from './productCard';
import { useMediaQuery } from 'react-responsive';
import { breakPoints } from 'app/constants';
import classNames from 'classnames';
import { ConfigProvider, theme, Button } from 'antd';
import { ShopBreadcrumbs } from './shopBreadcrumbs';
import { CustomModal } from '../../../shared/customModal/customModal';
import { Left } from 'app/shared/assets';
import { Counter } from 'app/shared/counter/counter';

function Image({ route, image, ...rest }) {
    let src = route,
        img = 'no-foto.png';
    if (image) {
        src += 'api/shop/images/medium/';
        img = image.replace('.jpg', '');
    } else {
        src += 'img/';
    }

    return <img src={src + img} {...rest} />;
}

const ShopModalContent = ({
    addProduct,
    product,
    shopStateProduct,
    user,
    point,
    setProductQty,
    route,
    destroyProduct,
    removeClickProduct,
    currency,
    setting,
    isMobile,
    closeModal,
}) => {
    const {
        discount,
        images = [],
        discounts,
        discount_percent,
        type,
    } = product;
    const gallery = useMemo(() => {
        if (!images.length) return [];
        return [product?.image, ...images?.map((image) => image.name)];
    }, [images]);
    const [focus, setFocus] = useState(false);
    const [startX, setStartX] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [activeGallery, setActiveGallery] = useState(0);
    const [productCounterQty, setProductCounterQty] = useState(
        (shopStateProduct ? shopStateProduct.qty : 0) || 0
    );
    useEffect(() => {
        if (!shopStateProduct?.qty) setProductCounterQty(1);
    }, [shopStateProduct?.qty]);
    function plusCntProduct() {
        setProductCounterQty(productCounterQty + 1);
    }

    function onChangeCountProduct(e) {
        e.stopPropagation();
        setProductCounterQty(Float(e.target.value, 3));
    }

    function onBlur(e) {
        e.stopPropagation();
        if (e.target.value <= 0) {
            destroyProduct(product.id);
        }
        setFocus(false);
    }

    function minusCntProduct() {
        if (productCounterQty >= 1) setProductCounterQty(productCounterQty - 1);
    }

    const goToPrevious = () => {
        setActiveGallery((prevIndex) =>
            prevIndex === 0 ? gallery?.length - 1 : prevIndex - 1
        );
    };

    const goToNext = () => {
        setActiveGallery((prevIndex) =>
            prevIndex === gallery?.length - 1 ? 0 : prevIndex + 1
        );
    };

    const goToImage = (index) => {
        setActiveGallery(index);
    };

    const handleTouchStart = (e) => {
        setStartX(e.touches[0].clientX);
        setIsDragging(true);
    };

    const handleTouchEnd = (e) => {
        if (!isDragging || !startX) return;

        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (diff > 50) {
            goToNext();
        } else if (diff < -50) {
            goToPrevious();
        }

        setStartX(null);
        setIsDragging(false);
    };
    const addToCart = () => {
        setProductQty(product, product.id, productCounterQty);
        closeModal();
    };
    let props_product = product;
    let product_qty = (shopStateProduct ? shopStateProduct.qty : 0) || 0;
    const consideredPrice = getConsiderProductPriceByTypePrice(
        props_product,
        point.type_price_json,
        productCounterQty,
        user ? user.discount : 0
    );

    return (
        <div
            className={classNames('product-card-modal', {
                'product-card_mobile': isMobile,
            })}
        >
            {gallery?.length ? (
                <div>
                    <div
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                        className="product-card-modal__img"
                    >
                        <Image
                            alt={`${props_product.name}-${activeGallery}`}
                            route={route}
                            image={gallery[activeGallery]}
                            className="img-fluid d-block m-auto"
                        />
                        <div className={'product-card-modal__gallery-actions'}>
                            <button
                                onClick={goToPrevious}
                                className={'product-card-modal__gallery-action'}
                            >
                                <Left />
                            </button>
                            <button
                                onClick={goToNext}
                                className={
                                    'product-card-modal__gallery-action product-card-modal__gallery-action_right'
                                }
                            >
                                <Left />
                            </button>
                        </div>
                    </div>
                    <div className={'product-card-modal__gallery'}>
                        {gallery.map((img, index) => {
                            return (
                                <div
                                    onClick={() => goToImage(index)}
                                    key={index}
                                    className="product-card-modal__gallery-wrapper"
                                >
                                    <Image
                                        alt={props_product.name}
                                        route={route}
                                        image={gallery[index]}
                                        className="product-card-modal__gallery-img"
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <div className="product-card-modal__img">
                    <Image
                        alt={props_product.name}
                        route={route}
                        image={props_product?.image}
                        className="img-fluid d-block m-auto"
                    />
                </div>
            )}
            <div className={'product-card__info'}>
                <div className={'product-card__section'}>
                    <ShopBreadcrumbs
                        typeId={type?.id}
                        onLink={closeModal}
                        showOne
                    />

                    <div
                        className={'product-card__name'}
                        style={{
                            color: setting.content.products.productCard
                                .nameColor,
                        }}
                    >
                        {props_product.name}
                    </div>
                    {!props_product.description ? null : (
                        <div
                            className={'product-card__description'}
                            style={{
                                color: setting.content.products.productCard
                                    .descriptionColor,
                            }}
                        >
                            {textToHtml(props_product.description, true)}
                        </div>
                    )}
                </div>
                <div>
                    <div className="product-card__price__wrap">
                        <span className={'product-card__unit'}>
                            {props_product.total_qty}
                            {props_product?.unit?.name}
                        </span>
                        <span className={'product-card__price'}>
                            {consideredPrice.price_consider}
                            {currency}
                        </span>
                    </div>
                    <div className={'product-card__footer mt-2'}>
                        <div className={'product-card__footer__prices'}>
                            {discount_percent || size(discounts) ? (
                                <ProductTooltip
                                    product={product}
                                    currency={currency}
                                />
                            ) : null}
                            {discount ? (
                                <div className={'product-card__oldPrice'}>
                                    {consideredPrice.price_original}
                                    {currency}
                                </div>
                            ) : null}
                        </div>
                        <div className={'product-card__stock'}>
                            {!product.total_qty ||
                            product.total_qty <= 0 ? null : (
                                <span
                                    className="mr-auto"
                                    style={{
                                        background:
                                            setting.content.products.productCard
                                                .background,
                                        color: setting.content.products
                                            .productCard.infoColor,
                                    }}
                                >
                                    {product.total_qty}
                                    &nbsp;
                                    {product.unit.name}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="product-card-modal__buy mt-2">
                        <div style={{ minWidth: '141px' }}>
                            <Counter
                                counter={productCounterQty}
                                onPlus={plusCntProduct}
                                onMinus={minusCntProduct}
                                onChange={onChangeCountProduct}
                            />
                        </div>
                        <ProductButton onClick={addToCart}>
                            <span>Добавить</span>
                            <span>
                                {Float(
                                    consideredPrice.price_consider *
                                        productCounterQty
                                )}
                                &thinsp;
                                {currency}
                            </span>
                        </ProductButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const InputQty = forwardRef(
    ({ onPlus, onMinus, value, onChange, plusStyle, ...rest }, ref) => {
        return (
            <div ref={ref} className={'product-qty'}>
                <div className="product-qty__action" onClick={onMinus}>
                    <MinusOutlined />
                </div>
                <div className="product-qty__body">
                    <input value={value} onChange={onChange} {...rest} />
                </div>
                <div
                    className="product-qty__action"
                    style={plusStyle}
                    onClick={onPlus}
                >
                    <PlusOutlined />
                </div>
            </div>
        );
    }
);

export const ProductButton = forwardRef(({ children, ...props }, ref) => {
    const { token } = theme.useToken();
    return (
        <ConfigProvider
            theme={{
                components: {
                    Button: {
                        lineWidth: 2,
                        colorBorder: token.colorPrimary,
                        controlHeight: 28,
                        colorText: token.colorPrimary,
                    },
                },
            }}
        >
            <Button
                className="product-card-modal__btn"
                ref={ref}
                {...props}
                shape={'round'}
            >
                {children ? children : 'Добавить'}
            </Button>
        </ConfigProvider>
    );
});

const MapStateToProps = function mapStateToProps(state, props) {
    return {
        route: state.appState.route,
        setting: state.appState.setting,
        user: state.authState.user,
        currency: state.pointsState.currency,
        products: state.shopState.shopCase.products,
        point: state.shopState.order.point,
        shopStateProduct: find(
            state.shopState.shopCase.products,
            (product) => product.id === props.product.id
        ),
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        addProduct: (product) => {
            dispatch({
                type: 'add_product',
                product: product,
            });
        },
        removeClickProduct: (product) => {
            dispatch({
                type: 'remove_product',
                product: product,
            });
        },
        destroyProduct: function (product_id) {
            dispatch({
                type: 'destroy_product',
                product_id: product_id,
            });
        },
        setProductQty: function (product, product_id, qty) {
            dispatch({
                type: 'set_product_qty_with_product',
                product_id: product_id,
                qty: qty,
                product: product,
            });
        },
        closeModal: () => {
            dispatch(closeProductModal());
        },
    };
};

export const ShopModal = ({ product, closeModal, setting }) => {
    const isMobile = !useMediaQuery({
        query: breakPoints.xsMobile,
    });
    return (
        <CustomModal
            width={'auto'}
            className={classNames('product-card-modal-modal', {
                'product-card-modal-modal_mobile': isMobile,
            })}
            open={product}
            onCancel={() => closeModal()}
            styles={{
                background: setting.content.products.productCard.background,
                border: `1px solid ${setting.content.products.productCard.borderColor}`,
            }}
            uniqueClass={'lending-product-card-modal-uniqueClass'}
        >
            <ShopModalContentLink isMobile={isMobile} product={product} />
        </CustomModal>
    );
};

export const ShopModalLink = connect(
    (state) => {
        return {
            product: state.shopState.productModal,
            setting: state.appState.setting,
        };
    },
    (dispatch) => {
        return {
            closeModal: () => {
                dispatch(closeProductModal());
            },
        };
    }
)(ShopModal);

export const ShopModalContentLink = connect(
    MapStateToProps,
    mapDispatchToProps
)(ShopModalContent);
